<template>
  <v-layout row wrap justify-center>
    <v-btn
      style="position: absolute; top: -35px; right: 20px;"
      @click="print"
      fab
      dark
      small
      color="primary"
      class="hidden-print-only"
    >
      <v-icon>mdi-printer</v-icon>
    </v-btn>

    <v-flex xs11 class="text-xs-center mt-5">
      <v-layout row wrap>
        <v-flex xs12 class="display-1">Zaitoon Skin & Cosmetic Hospital</v-flex>
        <v-flex xs12>
          <span class="mx-2 headline text-capitalize">{{report.type}} Report</span>
        </v-flex>

        <v-flex xs12 mt-1>
          <span class="mx-2 subheading">{{report.startDate + ' - ' + report.endDate}}</span>
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- table -->
    <v-flex xs12 class="my-4 mx-4">
      <v-data-table :headers="headers" :items="report.data" hide-actions>
        <template slot="items" slot-scope="{item}">
          <td>{{ item.type | type }}</td>
          <td>{{ item.total }}</td>
          <td>{{ item.count }}</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  middleware: "admin",
  layout: "print",
  data() {
    return {
      headers: [
        { text: "Title", value: "type", sortable: false },
        { text: "Total (AFN)", value: "total", sortable: false },
        { text: "Count (Paid)", value: "count", sortable: false }
      ]
    };
  },
  computed: {
    report() {
      return this.$store.getters["base/reports"];
    }
  },
  methods: {
    print() {
      window.print();
    }
  },
  filters: {
    type: function(value) {
      const map = {
        expense: "Expenses",
        appointments: "Appointments",
        patient_procedure: "Procedures",
        patient_test: "Tests",
        prescriptions: "Prescriptions"
      };
      return map[value];
    }
  },
  mounted() {
    // window.print();
  }
};
</script>

<style>
.bordered-table table thead tr:not(.v-datatable__progress),
.bordered-table table tbody tr {
  height: 30px;
}
.bordered-table table thead tr th {
  color: white !important;
  background-color: rgb(0, 0, 0);

  border: 1px solid grey;
}

.bordered-table {
  border: 1px solid grey;
}
</style>